export default __webpack_public_path__ + "static/coach-cards-7997e62ba560d7b241514ba153cd5fc8.png";